import "whatwg-fetch";
import "es6-promise";
const headers = new Headers({
  Accept: "application/json",
  "Content-Type": "application/json",
});

function get(url) {
  return fetch(url, {
    credentials: "include",
    method: "GET",
    headers: headers,
  })
    .then((response) => {
      return handleReponse(url, response);
    })
    .catch((error) => {
      console.error(`Request failed. Url = ${url}. Message = ${error}`);
      return Promise.reject({ error: { message: "Request failed" } });
    });
}

function post(url, data) {
  return fetch(url, {
    credentials: "include",
    method: "POST",
    headers: headers,
    body: JSON.stringify(data),
  })
    .then((response) => {
      return handleReponse(url, response);
    })
    .catch((error) => {
      console.error(`Request failed. Url = ${url}. Message = ${error}`);
      return Promise.reject({ error: { message: "Request failed" } });
    });
}

function put(url, data) {
  return fetch(url, {
    credentials: "include",
    method: "PUT",
    headers: headers,
    body: JSON.stringify(data),
  })
    .then((response) => {
      return handleReponse(url, response);
    })
    .catch((error) => {
      console.error(`Request failed. Url = ${url}. Message = ${error}`);
      return Promise.reject({ error: { message: "Request failed" } });
    });
}

function handleReponse(url, response) {
  if (response.status === 200) {
    return response.json();
  } else {
    console.error(`Request failed. Url = ${url}`);
    return Promise.reject({
      error: { message: "Request failed due to server error" },
    });
  }
}

export { get, post, put };



// WEBPACK FOOTER //
// ./src/utils/request.js